import { useMutation, useQueryClient } from "@tanstack/react-query"
import { forwardRfqToSeller, type ForwardRfqPayload } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useForwardRfq() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: ForwardRfqPayload) => {
      if (!accessToken) throw new Error("Not authenticated")
      return forwardRfqToSeller(payload, accessToken)
    },
    onSuccess: () => {
      // Invalidate queries to trigger refresh
      queryClient.invalidateQueries({ queryKey: ["admin-rfqs"] })
      queryClient.invalidateQueries({ queryKey: ["admin-to-seller-rfqs"] })
    },
    onError: (error: Error) => {
      console.error("RFQ forwarding failed:", error.message)
    },
  })
}
